var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9428 20.1667H17.0555C18.6654 20.1667 19.307 19.1808 19.3828 17.9792L19.6861 13.1608C19.7678 11.9008 18.7645 10.8333 17.4988 10.8333C17.143 10.8333 16.8164 10.6292 16.6531 10.3142L16.2331 9.46833C15.9648 8.9375 15.2649 8.5 14.67 8.5H13.3343C12.7335 8.5 12.0336 8.9375 11.7653 9.46833L11.3453 10.3142C11.182 10.6292 10.8553 10.8333 10.4995 10.8333C9.23384 10.8333 8.23061 11.9008 8.31227 13.1608L8.61557 17.9792C8.68557 19.1808 9.333 20.1667 10.9428 20.1667Z",
    stroke: "#0195D3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.123 12H14.8729",
    stroke: "#0195D3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 17.8346C15.0442 17.8346 15.8958 16.983 15.8958 15.9388C15.8958 14.8946 15.0442 14.043 14.0001 14.043C12.9561 14.043 12.1045 14.8946 12.1045 15.9388C12.1045 16.983 12.9561 17.8346 14.0001 17.8346Z",
    stroke: "#0195D3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.78c376a3dd43648859dc8cca789ab77e.svg";
export { ForwardRef as ReactComponent };